export default __webpack_public_path__ + "static/badge-best-gold-b106170c792ea2f214f6c390ba81f011.svg";